<template>
  <div>
      <b-modal id="tags-modal"  size="md" hide-footer @shown="modalShown">

            <h4>Manage Order Tags <b-spinner v-show="processing" type="grow" label="Spinning"></b-spinner></h4>
            
           <vue-tags-input
              v-model="tag"
              :tags="tags"
              :autocomplete-items="filteredItems"
              @tags-changed="tagUpdated"
            />

          <b-button class="mt-3" block variant="secondary" @click="$bvModal.hide('tags-modal')">Close Tags Editor</b-button>

      </b-modal>
  </div>
</template>

<script>
 import EventBus from '../../EventBus';
 import VueTagsInput from '@johmun/vue-tags-input';
 import OrderTagsService from '../../services/order-tags.service';
 
  export default {
      data() {
          return {
            tagValues: [],
            tag: '',
            tags: [],
            id: '',
            processing: false,
            autocompleteItems: [{
                text: 'Aamil',
              }, {
                text: 'Javed',
              }, {
                text: 'Anjali',
              }],
          }
        },
      components: {VueTagsInput},
      mounted(){
         EventBus.$on('order-tags', ({tags, id}) => {
            
            this.tags = []
            this.id = id;

            if(tags){
              this.tags = tags.trim().split(',').map(val => {
                 return {text: val}
              })
            }

            this.fetchStoreOrderTags();

         })

         
      },
      methods: {
        async tagUpdated(newTags){
            this.tags = newTags;
            
            this.tagValues = this.tags.map(tag => (tag.text));
            this.processing = true;
            let updateStatus = await OrderTagsService.updateOrderTags(this.id, this.tagValues);
            this.processing = false;
            EventBus.$emit('order-tag-updated', {id: this.id, tags: this.tagValues})
            console.log(updateStatus)
        },
        modalShown(){
          console.log('modal shown')
        },
        async fetchStoreOrderTags(){

           const existingTags = await OrderTagsService.fetchOrderTags(this.id);
           
           this.autocompleteItems = existingTags.data.tags.map(singleTag => {
               return {text: singleTag.tag}
           });
           
        }
      },
      computed: {
        filteredItems() {
          return this.autocompleteItems.filter(i => {
            return i.text.toLowerCase().indexOf(this.tag.toLowerCase()) !== -1;
          });
        },
      },
      beforeDestroy(){
        EventBus.$off('order-tags');
      }
  }
</script>

<style lang="scss" scoped>

</style>